import { create } from 'app/utils/data'

export default {
  namespaced: true,

  state: {},

  mutations: {
    resetState: (state) => state
  },

  actions: {
    sendEmail({ state }) {
      return new Promise((resolve, reject) => {
        create({
          url: '/api/account-confirmation-requests',
          type: 'account-confirmation-request',
          data: {}
        })
          .then(resolve)
          .catch(reject)
      })
    }
  }
}
